import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/static/play-icon_blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-02881aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded", "data-side-information"]
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  width: "15",
  height: "15",
  alt: "icon",
  class: "play-icon"
}
const _hoisted_3 = { class: "editor-accordion" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['accordion-item', { active: _ctx.active }, { inactive: !_ctx.active }])
  }, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      class: "accordion-item__title",
      "aria-expanded": _ctx.active,
      "data-side-information": _ctx.correctText()
    }, [
      _createElementVNode("span", {
        class: _normalizeClass([
          { content: !_ctx.content.isBlocked },
          { upcoming: !_ctx.content.isReleased, available: _ctx.content.isNew }
        ]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('clickContent')), ["stop"]))
      }, [
        (!_ctx.content.isBlocked && _ctx.content.isReleased)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.content.title), 1)
      ], 2)
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_TUIViewer, {
        modelValue: _ctx.content.description,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.content.description) = $event)),
        "max-width": "100%"
      }, null, 8, ["modelValue"]), [
        [_vShow, _ctx.active]
      ])
    ])
  ], 2))
}